<template>
    <div class="btn-toolbar float-right" role="toolbar">
        <div class="btn-group mr-2 mt-2" role="group">
            <font-awesome-icon
                icon="info-circle"
                title="Information"
                size="lg"
                color="#999"
                class="clickIcon"
                @click="displayInformationModal"
                :name="'informationAction' + index"
            />
        </div>
        <div class="btn-group mr-2 mt-2" role="group">
            <font-awesome-icon
                :icon="getDeliveryStatusIcon()"
                :title="this.shipment.deliveryStatus"
                size="lg"
                :class="isAdminOrSuperUser ? 'clickIcon' : ''"
                :color="getDeliveryStatusIconColor()"
                @click="displayTransitStatusModal"
                :name="'deliveryStatusAction' + index"
            />
        </div>
        <div v-if="isAdminOrSuperUser" class="btn-group mr-2 mt-2" role="group">
            <font-awesome-icon
                :icon="shipment.hasInternalNotes ? 'file-alt' : 'file'"
                size="lg"
                color="#999"
                title="Internal Notes"
                class="clickIcon"
                :name="'internalNotesAction' + index"
                @click="displayInternalMessagesModal"
            />
        </div>
        <div class="btn-group mr-2 mt-2" role="group">
            <font-awesome-icon
                icon="file-invoice-dollar"
                size="lg"
                class="clickIcon"
                :color="shipment.hasInvoice ? '#0b5a28' : '#999'"
                :title="shipment.hasInvoice ? 'Show Invoice' : 'Create Invoice'"
                @click="goToShowInvoice()"
            />
        </div>
        <div class="btn-group" role="group">
            <b-dropdown
                size="sm"
                :name="'historyActions' + index"
                :text="$t('history.buttons.Actions')"
                class="mr-2 mt-1"
            >
                <component
                    v-bind:is="'b-dropdown-item-button'"
                    v-for="(item, index) in sortedActions"
                    v-bind:key="index"
                    v-bind="item.props"
                    @click.native="item.clickEvent"
                >{{ item.text }}</component>
            </b-dropdown>
        </div>

        <changeReferenceModal ref="displayReferenceModal" :shipment="shipment" />
        <changeTrackingModal ref="displayTrackingModal" :shipment="shipment" />
        <internalMessagesModal
            ref="displayInternalMessagesModal"
            :shipment="shipment"
        />
        <changeShipDateModal ref="displayShipDateModal" :shipment="shipment" />
        <changeExpectedDeliveryDate ref="displayExpectedDeliveryDateModal" :shipment="shipment" />
        <changeTransitStatusModal
            @updateTransitStatus="updateTransitStatus"
            ref="displayTransitStatusModal"
            :deliveryStatus="shipment.deliveryStatus"
        />
        <changeShipAWBModal ref="displayShipAWBModal" :shipment="shipment" />
        <sendEmailModal ref="displayEmailModal" :shipment="shipment" />
        <setPriceLinesModal
            ref="displayPriceLinesModal"
            :shipmentId="shipment.id"
        />
      <setCostPriceLinesActionModel
          ref="displayCostPriceLinesModal"
          :shipmentId="shipment.id"
      />
        <informationModal ref="displayInformationModal" :shipment="shipment" />
        <confirmModal ref="deleteConfirmModal" @confirmAction="deleteShipment" />
        <confirmModal
            ref="transferCWConfirmModal"
            @confirmAction="transferShipmentToCW"
        />
        <restoreConfirmModel
            ref="restoreConfirmModal"
            @confirmAction="restoreShipment"
            :showRestoreAndBookInsurance="shipment.isInsured"
        />
        <uploadDocumentModal
            ref="uploadDocumentModal"
            :shipmentId="shipment.id"
        />
        <a
            download
            :id="downloadId"
            :href="linkToDownload"
            style="display: none;"
        ></a>
    </div>
</template>
<script>
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX, GETTERS } from '@/store/constants';
  import helpers from '@/helper';
  import restoreConfirmModel from '../History/Actions/restoreConfirmModel';
  import changeReferenceModal from '../History/Actions/senderReceiverAction';
  import changeTrackingModal from '../History/Actions/changeTrackingAction';
  import changeExpectedDeliveryDate from '../History/Actions/changeExpectedDeliveryDateAction.vue';
  import changeShipDateModal from '../History/Actions/changeShipDateAction';
  import changeShipAWBModal from '../History/Actions/changeAWBNumberAction';
  import changeTransitStatusModal from '../History/Actions/changeTransitStatusAction';
  import internalMessagesModal from '../History/Actions/internalInfoAction';
  import sendEmailModal from '../History/Actions/sendEmailsAction';
  import setPriceLinesModal from '../History/Actions/setPriceLinesAction';
  import informationModal from '../History/Actions/informationAction';
  import confirmModal from '../confirmModal';
  import uploadDocumentModal from '../uploadShipmentDocumentModal';
  import viewOptions from '@/mixins/viewOptionsMixin';
  import { mapGetters } from 'vuex';
  import setCostPriceLinesActionModel from "@/components/History/Actions/setCostPriceLinesAction.vue";

  export default {
      props: {
          shipment: { type: Object, required: true },
          index: { type: Number },
      },

      mixins: [viewOptions],

      components: {
        setCostPriceLinesActionModel,
          changeReferenceModal,
          changeTrackingModal,
          changeShipDateModal,
          changeExpectedDeliveryDate,
          changeShipAWBModal,
          changeTransitStatusModal,
          internalMessagesModal,
          sendEmailModal,
          setPriceLinesModal,
          informationModal,
          confirmModal,
          uploadDocumentModal,
          restoreConfirmModel,
      },
      data() {
          return {
              linkToDownload: null,
          };
      },

      computed: {
          ...mapGetters('core', [
              'getHeaderData',
              'isAdminOrSuperUser',
              'isCustomer',
              'getShipmentSystem',
          ]),
          ...mapGetters('history', [GETTERS.HISTORY.GET_FILTER]),
          sortedActions() {
              return this.actions.sort((a, b) => a.text.localeCompare(b.text));
          },
          downloadId() {
              return 'downloadLink' + this.shipment.id;
          },
          actions() {
              let actions = [
                  {
                      text: this.$t('history.buttons.ChangeAWB'),
                      clickEvent: this.displayShipAWBModal,
                      show: this.isAdminOrSuperUser,
                      props: { name: 'changeAwb' },
                  },
                  {
                      text: this.$t('history.buttons.ChangeReference'),
                      show: this.showAction('changeReference'),
                      clickEvent: this.displayChangeReferenceModal,
                      props: { name: 'changeSendersReceiversReference' },
                  },
                  {
                      text: this.$t('history.buttons.DownloadAWB'),
                      clickEvent: this.downloadAwb,
                      show: this.showAction('downloadAwb'),
                      props: { name: 'downloadAwb' },
                  },
                  {
                      text: this.$t('history.buttons.SendEmails'),
                      clickEvent: this.displayEmailModal,
                      show: this.isAdminOrSuperUser,
                      props: { name: 'sendEmails' },
                  },
                  {
                      text: this.$t('history.buttons.ChangeShipDate'),
                      clickEvent: this.displayShipDateModal,
                      show: this.isAdminOrSuperUser,
                      props: { name: 'changeShipDate' },
                  },
                  {
                    text: this.$t('history.buttons.ChangeExpectedDeliveryDate'),
                    clickEvent: this.displayExpectedDeliveryDateModal, 
                    show: this.isAdminOrSuperUser,
                    props: { name: 'changeExpectedDeliveryDate' },
                  },
                  {
                      text: this.$t('history.buttons.ChangeTracking'),
                      clickEvent: this.displayTrackingModal,
                      show: this.isAdminOrSuperUser,
                      props: { name: 'changeTrackingLink' },
                  },
                  // {
                  //     text: 'Create Claim',
                  //     show: this.showAction('createClaim'),
                  //     clickEvent: this.goToCreateClaim,
                  // },
                  {
                      text: this.$t('history.buttons.DeleteShipment'),
                      show: this.showAction('delete'),
                      clickEvent: this.displayConfirmModel,
                      props: { id: 'deleteAction', name: 'deleteAction' },
                  },
                  {
                      text: this.$t('history.buttons.CopyShipment'),
                      clickEvent: this.copyShipment,
                      show: this.showAction('copy'),
                      props: { name: 'copyShipment' },
                  },
                  {
                      text: this.$t('history.buttons.EditShipment'),
                      clickEvent: this.editShipment,
                      show: this.showAction('edit'),
                      props: { name: 'editShipment' },
                  },
                  {
                      text: this.$t('history.buttons.SetPriceAccount'),
                      clickEvent: this.displayPriceLinesModal,
                      show: this.isAdminOrSuperUser,
                      props: { name: 'setPriceAccount' },
                  },
                  {
                      text: this.$t('history.buttons.SetCostPriceAccount'),
                      clickEvent: this.displayCostPriceLinesModal,
                      show: this.isAdminOrSuperUser,
                      props: { name: 'setPriceAccount' },
                  },
                  {
                      text: this.$t('history.buttons.NewInvoice'),
                      show: true,
                      clickEvent: this.newInvoice,
                      props: { name: 'newInvoice' },
                  },
                  {
                      text: this.$t('history.buttons.UploadDocument'),
                      show: this.showAction('uploadDocument'),
                      clickEvent: this.showUploadDocumentModal,
                      props: { name: 'actionsUploadDocument' },
                  },
                  {
                      text: this.$t('history.buttons.RestoreShipment'),
                      show: this.isAdminOrSuperUser && this.showAction('restore'),
                      clickEvent: this.showRestoreConfirmModel,
                      props: { id: 'restoreAction', name: 'restoreAction' },
                  },
                  {
                      text: this.$t('history.buttons.TransferToCargoWise'),
                      show: this.isAdminOrSuperUser && this.shipment.allowCargoWiseTransfer,
                      clickEvent: this.displayTransferToCWModel,
                      props: { id: 'transferCWAction', name: 'transferCWAction' },
                  },
                  {
                      text: this.$t('history.buttons.ReturnShipment'),
                      clickEvent: this.returnShipment,
                      show: this.showAction('returnShipment'),
                      props: { name: 'returnShipment' },
                  },
                  {
                      text: this.$t('history.buttons.ReturnShipmentImport'),
                      clickEvent: this.returnShipmentImport,
                      show: this.showAction('returnShipmentImport'),
                      props: { name: 'returnShipmentImport' },
                  }
              ];

              return actions.filter((x) => x.show === true);
          },
      },

      methods: {
          showRestoreConfirmModel() {
              this.$refs['restoreConfirmModal'].show();
          },
          updateTransitStatus(value) {
              var request = {
                  shipmentIds: [this.shipment.id],
                  deliveryStatus: value,
              };

              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.UPDATE_TRANSIT_STATUS, request);
          },
          hideActionMenu(bvEvt) {
              if (bvEvt.vueTarget.clickOutElement.activeElement.id == 'deleteAction') {
                  bvEvt.preventDefault();
              }
          },
          showAction(action) {
              if (action === 'edit') {
                  return this.shipment.canEdit;
              }

              if (action === 'delete') {
                  if (this.getFilter && this.getFilter.deleted) {
                      return false;
                  }
                  return this.shipment.isDeletable;
              }
              if (action === 'restore') return this.getFilter && this.getFilter.deleted;

              return true;
          },
          goToCreateClaim() {
              window.open(
                  this.getHeaderData.claimModuleLink +
                      `/home/${this.getShipmentSystem}/${this.shipment.id}`,
                  '_blank'
              );
          },
          newInvoice() {
              this.$router.push({ name: 'invoice', params: { shipmentId: this.shipment.id } });
          },
          showUploadDocumentModal() {
              this.$refs['uploadDocumentModal'].show();
          },
          deleteShipment() {
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.DELETE_SHIPMENTS, [
                  this.shipment.id,
              ]);
          },

          transferShipmentToCW() {
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.TRANSFER_SHIPMENT, [
                  this.shipment.id,
              ]);
          },

          restoreShipment(bookInsurance) {
              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.RESTORE_SHIPMENTS, {
                  ids: [this.shipment.id],
                  bookInsurance: bookInsurance,
              });
          },
          async downloadAwb() {
              this.linkToDownload = await this.$store.dispatch(
                  HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_LABEL,
                  this.shipment.id
              );
              if (this.linkToDownload) {
                  document.getElementById(this.downloadId).click();
              }
          },
          copyShipment() {
              this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);
              this.$router.push('/Createbooking?id=' + this.shipment.id + '&copy=true');
          },
          returnShipment() {
              this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);
              this.$router.push('/Createbooking?id=' + this.shipment.id + '&returnShipment=true&copy=true&action=returnShipmentFromLink');
          },
          returnShipmentImport() {
              this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);
              this.$router.push('/Createbooking?id=' + this.shipment.id + '&copy=true&import=true&action=returnShipment');
          },
          editShipment() {
              this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, true);
              this.$router.push('/Createbooking?id=' + this.shipment.id);
          },
          displayConfirmModel() {
              this.$refs['deleteConfirmModal'].show();
          },
          displayTransferToCWModel() {
              this.$refs['transferCWConfirmModal'].show();
          },
          displayChangeReferenceModal() {
              this.$refs['displayReferenceModal'].showReferenceModal();
          },
          displayTrackingModal() {
              this.$refs['displayTrackingModal'].showTrackingModal();
          },
          displayInternalMessagesModal() {
              this.$refs['displayInternalMessagesModal'].showInternalMessagesModal();
          },
          displayShipDateModal() {
              this.$refs['displayShipDateModal'].showChangeShipDateModal();
          },
          displayExpectedDeliveryDateModal() {
            this.$refs['displayExpectedDeliveryDateModal'].showChangeExpectedDeliveryDateModal();
          },
          displayShipAWBModal() {
              this.$refs['displayShipAWBModal'].showChangeAWBModal();
          },
          displayEmailModal() {
              this.$refs['displayEmailModal'].showSendEmailsModal();
          },
          displayPriceLinesModal() {
              this.$refs['displayPriceLinesModal'].showAddPriceLinesModal();
          },
          displayCostPriceLinesModal() {
          this.$refs['displayCostPriceLinesModal'].showAddPriceLinesModal();
          },
          displayTransitStatusModal() {
              if (this.isAdminOrSuperUser) {
                  this.$refs['displayTransitStatusModal'].showTransitStatusModal();
              }
          },
          displayInformationModal() {
              this.$refs['displayInformationModal'].showInformationModal();
          },

          getDeliveryStatusIconColor() {
              if (this.shipment.deliveryStatus === 'Delivered') {
                  return '#0ead36';
              } else if (this.shipment.deliveryStatus === 'Delayed') {
                  return '#ed2121';
              } else if (this.shipment.deliveryStatus === 'Transit') {
                  return '#fcba03';
              } else {
                  return '#345495 ';
              }
          },
          getDeliveryStatusIcon() {
              if (this.shipment.deliveryStatus === 'Created') {
                  return 'warehouse';
              }
              if (this.shipment.deliveryStatus === 'Transit') {
                  return 'truck';
              }
              if (this.shipment.deliveryStatus === 'Delayed') {
                  return 'times-circle';
              }
              if (this.shipment.deliveryStatus === 'Delivered') {
                  return 'check';
              }
          },
          async goToShowInvoice() {
            if(this.shipment.systemInvoiceLink && this.shipment.hasInvoice){
              window.open(this.shipment.systemInvoiceLink, '_blank')
            }
            else if(this.shipment.systemInvoiceLink == null && this.shipment.hasInvoice){
              let response = await this.$store.dispatch(
                  HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_HISTORY_SHIPMENT_INFO,
                  this.shipment.id
              );
              window.open(response.documents.find((element) => element.type == 'Invoice').storageLink, '_blank')
            }
            else{
              this.$router.push({ name: 'invoice', params: { shipmentId: this.shipment.id } });
            }
          },
      },
  };
</script>

<style>
  .clickIcon {
      cursor: pointer;
  }
</style>
